import React from 'react';
import { TTypeOfModalWindow } from '../../../../../editSubcategoryState/editSubcategoryContext';
import { Form } from 'antd';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

interface IProps {
	changeTypeOfModalWindow: (value: TTypeOfModalWindow) => void;
}

export const BtnBlock: React.FC<IProps> = React.memo(({ changeTypeOfModalWindow }) => {
	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
});
